import { getFieldSectionName as getLayoutSectionName, getPanelFieldLabel, groupFieldsByPage } from './editorPanelLayout';
import {
  getEditorPanelDetailPreview,
  hasEditorPanelDetail,
  shouldHideFromEditorPanel,
} from '../components/editable/editorPanelFieldDetails';

export const PAGE_EDITOR_META = {
  '/': { title: 'Home', slug: 'home' },
  '/story': { title: 'Our Story', slug: 'story' },
  '/ministries': { title: 'Ministries', slug: 'ministries' },
  '/watch': { title: 'Watch', slug: 'watch' },
  '/gallery': { title: 'Gallery', slug: 'gallery' },
  '/beliefs': { title: 'Beliefs', slug: 'beliefs' },
  '/visit-us': { title: 'Visit Us', slug: 'visit' },
  '/new-here': { title: 'New Here', slug: 'newhere' },
};

export function getPageEditorMeta(pathname) {
  return PAGE_EDITOR_META[pathname] || null;
}

export function getFieldSectionName(contentKey, pathname = '/') {
  return getLayoutSectionName(contentKey, pathname);
}

export function getFieldShortLabel(contentKey) {
  return getPanelFieldLabel(contentKey);
}

export function getFieldPreview(element) {
  if (!element) return '';

  const contentKey = element.getAttribute('data-content-key');
  if (contentKey && hasEditorPanelDetail(contentKey)) {
    return getEditorPanelDetailPreview(contentKey, element);
  }

  if (
    element.classList.contains('church-calendar-section') ||
    element.querySelector('.church-month-calendar')
  ) {
    return 'Add or edit events on the page calendar';
  }

  if (element.getAttribute('data-content-key') === 'home.sermons.items') {
    const count = element.querySelectorAll('.video-container').length;
    return count ? `${count} videos — click to expand` : 'Click to expand';
  }

  if (/^ministries\.\d+\.images$/.test(element.getAttribute('data-content-key') || '')) {
    const count = element.querySelectorAll('.dialog-image-item:not(.dialog-image-item--add)').length;
    return count ? `${count} photos — hover image and click Edit` : 'Hover and click Edit on each photo';
  }

  if (/^watch\.section\.\d+\.videos$/.test(element.getAttribute('data-content-key') || '')) {
    const count = element.querySelectorAll('.video-item-wrap:not(.video-item-wrap--add)').length;
    return count ? `${count} videos — click to expand` : 'Click to expand';
  }

  if (element.closest('.videos-grid[data-content-key="home.sermons.items"]')) {
    return 'Click to expand and edit video & thumbnail URLs';
  }

  const textNode = element.cloneNode(true);
  textNode.querySelectorAll('.editable-image-toolbar, .hero-slide-add, .editable-list-actions, .editable-list-footer, .editable-list-remove, .video-edit-trigger').forEach((node) => node.remove());
  const text = (textNode.textContent || '').replace(/\s+/g, ' ').trim();
  if (!text) {
    if (element.tagName === 'IMG') return 'Image';
    if (element.classList.contains('editable-background') || element.closest('.editable-background')) {
      return 'Background image';
    }
    if (element.closest('.editable-image-wrap')) {
      return 'Image';
    }
    if (element.children.length > 8) {
      const nestedEditable = element.querySelector('[data-content-key]');
      if (nestedEditable && nestedEditable !== element) {
        return getFieldPreview(nestedEditable);
      }
    }
    return 'Media';
  }

  return text.length > 72 ? `${text.slice(0, 72)}…` : text;
}

export function getFieldType(element) {
  const contentKey = element.getAttribute('data-content-key');
  if (contentKey === 'home.sermons.items') return 'videos';
  if (contentKey === 'home.hero.slides') return 'gallery';
  if (contentKey === 'beliefs.values.items') return 'text';
  if (contentKey === 'beliefs.items') return 'text';
  if (/^ministries\.\d+\.images$/.test(contentKey || '')) return 'gallery';
  if (/^watch\.section\.\d+\.videos$/.test(contentKey || '')) return 'videos';
  if (element.classList.contains('editable-text')) return 'text';
  if (element.classList.contains('editable-background') || element.closest('.editable-background')) return 'background';
  if (element.closest('.editable-image-wrap') || element.tagName === 'IMG') return 'image';
  if (element.closest('.editable-gallery-item')) return 'gallery';
  return 'content';
}

export function groupFieldsBySection(fields, pathname = '/') {
  return groupFieldsByPage(fields, pathname);
}

export function shouldSkipEditorPanelField(contentKey) {
  return shouldHideFromEditorPanel(contentKey);
}
